module.exports = __webpack_public_path__ + "img/svg/copy.de8d2311c4b740ba22f55de579ae6f97.svg";